














import { Vue, Component, Prop } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import InvestigationModel from '@/models/investigation/investigationModel'
import ListSectionModel from '@/models/navigation/listSectionModel'
import NavigationModel from '@/models/navigation/navigationModel'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule.ts'
import SectionedList from '@/components/lists/SectionedList.vue'

const titleModule = getModule(TitleModule)

@Component({
  components: {
    SectionedList
  }
})
export default class Investigation extends Vue {
  @Prop(String) readonly id!: string

  private categories: Array<ListSectionModel<NavigationModel>> = [
    new ListSectionModel<NavigationModel>('Investigation Information', [
      new NavigationModel('Scene Management', 'stage', {
        stage: 'scene-management',
        id: this.id
      }),
      new NavigationModel('Equipment', 'stage', {
        stage: 'equipment',
        id: this.id
      }),
      new NavigationModel('Personnel', 'stage', {
        stage: 'personnel-profiles',
        id: this.id
      }),
      new NavigationModel('Documents', 'stage', {
        stage: 'documents',
        id: this.id
      }),
      new NavigationModel('Witness Interviews', 'extensionInfo', {
        stage: 'witness-interviews',
        id: this.id
      }),
      new NavigationModel('Findings', 'findings', {
        id: this.id
      })
    ])
    // new ListSectionModel<NavigationModel>('Investigation Outcomes', [
    //   new NavigationModel('Root Causes', 'rootCauses', { id: this.id }),
    //   new NavigationModel('Suggested Actions', 'suggestedActions', {
    //     id: this.id
    //   }),
    //   new NavigationModel('Best Practice', 'extensionInfo', {
    //     stage: 'best-practice',
    //     id: this.id
    //   })
    // ])
  ]

  private async created() {
    await this.getInvestigation()
  }

  private navigate(item: NavigationModel): void {
    this.$router.push({
      name: item.route,
      params: item.params
    })
  }

  private async getInvestigation(): Promise<void> {
    const investigation = await ApiService.get<InvestigationModel>(
      UrlType.Investigation,
      this.id
    )

    titleModule.setPageTitle(investigation.name)
  }
}
